export default "__VITE_ASSET__c7d07d27__"